import { CalendarDays } from "lucide-react"
import { useLang } from "../context/LangContext"

const T = {
  en: {
    title: "Economic Calendar",
    sub: "Track key economic events related to stocks and ETFs. Stay informed about macroeconomic releases and respond to market movements with confidence.",
    disclaimer: "uCloud360 is not responsible for the information displayed in this calendar. All data is provided by Investing.com.",
  },
  es: {
    title: "Calendario Económico",
    sub: "Sigue los eventos económicos clave relacionados con acciones y ETF. Mantente informado sobre las publicaciones macroeconómicas y responde a los movimientos del mercado con confianza.",
    disclaimer: "uCloud360 no es responsable de la información mostrada en este calendario. Todos los datos son proporcionados por Investing.com.",
  },
}

export default function EconomicCalendarPage() {
  const { lang } = useLang()
  const t = T[lang]
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-black text-gray-900 dark:text-gray-100">
      <main className="mx-auto max-w-6xl px-6 py-10">
        <section className="flex items-start gap-3">
          <div className="rounded-xl border border-gray-200 dark:border-gray-800 p-2 flex-shrink-0">
            <CalendarDays className="h-5 w-5" />
          </div>
          <div>
            <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight">{t.title}</h1>
            <p className="mt-2 text-gray-600 dark:text-gray-400 max-w-3xl">{t.sub}</p>
          </div>
        </section>

        <section className="mt-10 rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-black p-6">
          <div className="w-full overflow-x-auto">
            <iframe
              title="Economic Calendar"
              src="https://sslecal2.investing.com?columns=exc_flags,exc_currency,exc_importance,exc_actual,exc_forecast,exc_previous&features=datepicker,timezone,filters&countries=5&calType=day&timeZone=8&lang=1"
              width="100%"
              height="670"
              frameBorder="0"
              allowTransparency
              className="rounded-xl"
            />
          </div>
          <p className="mt-4 text-xs text-gray-400 dark:text-gray-500">{t.disclaimer}</p>
        </section>
      </main>
    </div>
  )
}
